import React from 'react'
import { useState } from "react";

import { useDispatch } from "react-redux";
import { toAbsoluteUrl } from "../../../Utils/_helpers";
import { Alert } from "../../util/alerts";
import { getCallConferenceAgent, getCallSessionAgent } from "./api";
import { cancelAddAgentToConference } from "./CallService";
import * as constants from "./constants";
import { getName } from "./helpers";
import { LiveCallMinimized } from "./LiveCallMinimized";
import { actionTypes } from "./reducer";

export function CallConferenceInitiated(props) {
  const dispatch = useDispatch();

  const sessionAgent = getCallSessionAgent();
  const legCAgent = getCallConferenceAgent();

  const [msg, setMsg] = useState(null);
  const reset = () => {
    setMsg(null);
  };
  const setViewState = (view_state) => {
    dispatch({
      type: actionTypes.onCallViewState,
      payload: { view_state: view_state },
    });
  };

  return (
    <>
      <div className="tmodal tmodal-dialog-scrollable call-ticker-dialog-sec">
        <div className="tmodal-content" style={{ boxShadow: "none" }}>
          <LiveCallMinimized {...props} disableSymbols={true} />

          <div className="initiated-conference-title-sec">
            <div className="head-title-label">Call Conference</div>
            <div className="voice-indicator">
              <img
                alt=""
                className="voice-indicator-icon"
                src={toAbsoluteUrl("/media/sr/icons/voice-indicator-green.svg")}
              />
            </div>
          </div>
          <div className="tmodal-body">
            <div className="conference-sec">
              {msg && (
                <div className="mb-5">
                  <Alert msg={msg} onClose={reset} />
                </div>
              )}

              <div className="dialer">
                <div className="dialer-dp user-status">
                  <div className="dialer-dp-icon status-available">
                    {getName(sessionAgent)[0].toUpperCase()}
                  </div>
                </div>
                <div className="dialer-name">{getName(sessionAgent, 12)}</div>
              </div>
              <div className="conference-indicator-sec">
                <div className="conference-indicator"></div>
                <div className="conf-indicator-text">Connecting</div>
              </div>
              <div className="receiver">
                <div className="receiver-dp user-status">
                  <div className="dialer-dp-icon status-available">
                    {getName(legCAgent)[0].toUpperCase()}
                  </div>
                </div>
                <div className="receiver-name">{getName(legCAgent, 12)}</div>
              </div>
            </div>
            <div className="intitiated-sec">
              <div className="row justify-content-center intitiated-text">
                Call Intitiated
              </div>
              <div className="row justify-content-center wait-text">
                Please wait while we are connecting your call
              </div>
              <div className="row justify-content-center ">
                <button
                  type="button"
                  className="btn btn-sm cancel-btn"
                  onClick={async () => {
                    const result = await cancelAddAgentToConference(
                      props.callFlow,
                      legCAgent,
                      dispatch
                    );
                    if (result !== 200) {
                      setMsg("Request Error.");
                      setViewState(constants.CALL_VIEW_STATES.CALL_VIEW);
                    }
                  }}
                >
                  <span className="cancel-btn-text">Cancel</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
